(function () {
  var POPUP_COOLDOWN_HOURS = 24;

  document.querySelectorAll('[data-popup]').forEach(function (popup) {
    var cookieName = popup.getAttribute('data-cookie-name') || 'popup_announcement_closed';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var overlay = popup.querySelector('[data-popup-overlay]');
    var closeBtn = popup.querySelector('[data-popup-close]');

    function hasRecentlyClosed() {
      var lastClosed = localStorage.getItem(cookieName);
      if (!lastClosed) return false;

      var lastClosedTime = parseInt(lastClosed, 10);
      if (isNaN(lastClosedTime)) return false;

      var hoursSinceClosed = (Date.now() - lastClosedTime) / (1000 * 60 * 60);
      return hoursSinceClosed < POPUP_COOLDOWN_HOURS;
    }

    function openPopup() {
      popup.classList.add('popup-announcement--open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('popup-announcement-lock-scroll');
    }

    function closePopup() {
      popup.classList.remove('popup-announcement--open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('popup-announcement-lock-scroll');
      localStorage.setItem(cookieName, Date.now().toString());
    }

    if (!hasRecentlyClosed()) {
      setTimeout(openPopup, delay);
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('popup-announcement--open')) {
        closePopup();
      }
    });
  });
})();